<div class="fw-container d-flex flex-column">
  <span class="fw-transfer-text">Select a Field worker to transfer</span>

    <span class="fw-text mt-4 mb-1">Field worker</span>
    <form>
      <div class="d-flex flex-column">
        <mat-form-field class="select-mat-form-field mt-4">
          <mat-select
            class="custom-mat-select"
            [formControl]="fwName"
          >
            <mat-option value="default">(Select/search)</mat-option>
            @for (item of fwNames; track item) {
            <mat-option [value]="item.value">{{
              item.label
            }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button class="dp-primary-btn fw-btn mt-4 mb-4" type="button" (click)="transferWishlist()">Transfer</button>
        <span mat-dialog-close class="cancel-text text-center">No, cancel</span>
      </div>

    </form>

</div>
